import { Candle } from '../chart/types';

// Deterministic PRNG (mulberry32) so the demo chart looks identical on every
// load — no live feed yet. Replace generateCandles() with a websocket feed to
// the CCFOS API when the backend exists (see CLAUDE.md).
function mulberry32(seed: number) {
  return function () {
    seed |= 0;
    seed = (seed + 0x6d2b79f5) | 0;
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function generateCandles(count = 320, startPrice = 100, seed = 20260704): Candle[] {
  const rand = mulberry32(seed);
  const out: Candle[] = [];
  let price = startPrice;
  const msPerBar = 24 * 60 * 60 * 1000; // one bar per day
  let t = Date.UTC(2025, 0, 1);
  for (let i = 0; i < count; i++) {
    const drift = (rand() - 0.47) * 2; // faint upward bias
    const vol = 1 + rand() * 2.2;
    const open = price;
    const close = Math.max(1, open + drift * vol);
    const high = Math.max(open, close) + rand() * vol;
    const low = Math.max(0.5, Math.min(open, close) - rand() * vol);
    out.push({
      time: t,
      open,
      high,
      low,
      close,
      volume: Math.round(1000 + rand() * 9000),
    });
    price = close;
    t += msPerBar;
  }
  return out;
}
